export default "__VITE_ASSET__18d77424__"